/**
 * Sign PDF bake — same raster pipeline as watermark bake, Sign-owned API.
 */

import {
  bakeWatermarkedPdf,
  downloadBlob,
} from "../../shared/bakeWatermarkedPdf";

/**
 * @param {File} file
 * @param {object | object[] | ((pageNum: number, total: number) => object|object[]|null)} marksOrResolver
 * @param {{ scale?: number, maxPages?: number, fileNameSuffix?: string, onProgress?: Function }} [opts]
 */
export async function bakeSignedPdf(file, marksOrResolver, opts = {}) {
  if (!file) throw new Error("No PDF file");

  return bakeWatermarkedPdf(file, marksOrResolver, {
    ...opts,
    fileNameSuffix: opts.fileNameSuffix || "signed",
  });
}

/**
 * Bake + trigger browser download.
 */
export async function downloadSignedPdf(file, marksOrResolver, opts = {}) {
  const result = await bakeSignedPdf(file, marksOrResolver, opts);
  downloadBlob(result.blob, result.fileName);
  return result;
}
